// extracted by mini-css-extract-plugin
module.exports = {"loader":"orders_loader__H2OOq","cardHeader":"orders_cardHeader__oV_QR","eyeicon":"orders_eyeicon__g42ES"};